{
  "AF": "Afghanistan",
  "AL": "Albania",
  "DZ": "Algeria",
  "AD": "Andorra",
  "AO": "Angola",
  "AI": "Anguilla",
  "AQ": "Antarctica",
  "AG": "Antigua and Barbuda",
  "SA": "Saudi Arabia",
  "AR": "Argentina",
  "AM": "Armenia",
  "AW": "Aruba",
  "AU": "Australia",
  "AT": "Austria",
  "AZ": "Azerbaijan",
  "BS": "Bahamas",
  "BH": "Bahrain",
  "BD": "Bangladesh",
  "BB": "Barbados",
  "BE": "Belgium",
  "BZ": "Belize",
  "BJ": "Benin",
  "BM": "Bermuda",
  "BT": "Bhutan",
  "BY": "Belarus",
  "BO": "Bolivia",
  "BQ": "Bonaire, Sint Eustatius and Saba",
  "BA": "Bosnia and Herzegovina",
  "BW": "Botswana",
  "BR": "Brazil",
  "BN": "Brunei",
  "IO": "British Indian Ocean Territory",
  "VG": "British Virgin Islands",
  "BG": "Bulgaria",
  "BF": "Burkina Faso",
  "BI": "Burundi",
  "CL": "Chile",
  "CN": "China",
  "HR": "Croatia",
  "CW": "Curaçao",
  "CY": "Cyprus",
  "CZ": "Czechia",
  "UM": "United States Minor Outlying Islands",
  "DK": "Denmark",
  "CD": "Democratic Republic of the Congo",
  "DM": "Dominica",
  "DO": "Dominican Republic",
  "DJ": "Djibouti",
  "EG": "Egypt",
  "EC": "Ecuador",
  "ER": "Eritrea",
  "EE": "Estonia",
  "SZ": "Eswatini",
  "ET": "Ethiopia",
  "FK": "Falkland Islands",
  "FJ": "Fiji",
  "PH": "Philippines",
  "FI": "Finland",
  "FR": "France",
  "TF": "French Southern and Antarctic Territories",
  "GA": "Gabon",
  "GM": "Gambia",
  "GS": "South Georgia and the South Sandwich Islands",
  "GH": "Ghana",
  "GI": "Gibraltar",
  "GR": "Greece",
  "GD": "Grenada",
  "GL": "Greenland",
  "GE": "Georgia",
  "GU": "Guam",
  "GG": "Guernsey",
  "GF": "French Guiana",
  "GY": "Guyana",
  "GP": "Guadeloupe",
  "GT": "Guatemala",
  "GW": "Guinea-Bissau",
  "GQ": "Equatorial Guinea",
  "GN": "Guinea",
  "HT": "Haiti",
  "ES": "Spain",
  "NL": "Netherlands",
  "HN": "Honduras",
  "HK": "Hong Kong",
  "IN": "India",
  "ID": "Indonesia",
  "IQ": "Iraq",
  "IR": "Iran",
  "IE": "Ireland",
  "IS": "Iceland",
  "IL": "Israel",
  "JM": "Jamaica",
  "JP": "Japan",
  "YE": "Yemen",
  "JE": "Jersey",
  "JO": "Jordan",
  "KY": "Cayman Islands",
  "KH": "Cambodia",
  "CM": "Cameroon",
  "CA": "Canada",
  "QA": "Qatar",
  "KZ": "Kazakhstan",
  "KE": "Kenya",
  "KG": "Kyrgyzstan",
  "KI": "Kiribati",
  "CO": "Colombia",
  "KM": "Comoros",
  "ME": "Montenegro",
  "CG": "Congo",
  "KR": "South Korea",
  "KP": "North Korea",
  "CR": "Costa Rica",
  "CU": "Cuba",
  "KW": "Kuwait",
  "LA": "Laos",
  "LS": "Lesotho",
  "LB": "Lebanon",
  "LR": "Liberia",
  "LY": "Libya",
  "LI": "Liechtenstein",
  "LT": "Lithuania",
  "LU": "Luxembourg",
  "LV": "Latvia",
  "MK": "North Macedonia",
  "MG": "Madagascar",
  "YT": "Mayotte",
  "MO": "Macau",
  "MW": "Malawi",
  "MV": "Maldives",
  "MY": "Malaysia",
  "ML": "Mali",
  "MT": "Malta",
  "MP": "Northern Mariana Islands",
  "MA": "Morocco",
  "MQ": "Martinique",
  "MR": "Mauritania",
  "MU": "Mauritius",
  "MX": "Mexico",
  "FM": "Micronesia",
  "MM": "Myanmar",
  "MD": "Moldova",
  "MC": "Monaco",
  "MN": "Mongolia",
  "MS": "Montserrat",
  "MZ": "Mozambique",
  "NA": "Namibia",
  "NR": "Nauru",
  "NP": "Nepal",
  "DE": "Germany",
  "NE": "Niger",
  "NG": "Nigeria",
  "NI": "Nicaragua",
  "NU": "Niue",
  "NF": "Norfolk",
  "NO": "Norway",
  "NC": "New Caledonia",
  "NZ": "New Zealand",
  "OM": "Oman",
  "PK": "Pakistan",
  "PW": "Palau",
  "PS": "Palestine",
  "PA": "Panama",
  "PG": "Papua New Guinea",
  "PY": "Paraguay",
  "PE": "Peru",
  "PN": "Pitcairn",
  "PF": "French Polynesia",
  "PL": "Poland",
  "PR": "Puerto Rico",
  "PT": "Portugal",
  "ZA": "South Africa",
  "CF": "Central African Republic",
  "CV": "Cape Verde",
  "RE": "Reunion",
  "RU": "Russia",
  "RO": "Romania",
  "RW": "Rwanda",
  "EH": "Western Sahara",
  "KN": "Saint Kitts and Nevis",
  "LC": "Saint Lucia",
  "VC": "Saint Vincent and the Grenadines",
  "BL": "Saint-Barthélemy",
  "MF": "Saint-Martin",
  "PM": "Saint-Pierre and Miquelon",
  "SV": "Salvador",
  "AS": "American Samoa",
  "WS": "Samoa",
  "SM": "San Marino",
  "SN": "Senegal",
  "RS": "Serbia",
  "SC": "Seychelles",
  "SL": "Sierra Leone",
  "SG": "Singapore",
  "SX": "Sint Maarten",
  "SK": "Slovakia",
  "SI": "Slovenia",
  "SO": "Somalia",
  "LK": "Sri Lanka",
  "US": "United States",
  "SD": "Sudan",
  "SS": "South Sudan",
  "SR": "Suriname",
  "SJ": "Svalbard and Jan Mayen",
  "SY": "Syria",
  "CH": "Switzerland",
  "SE": "Sweden",
  "TJ": "Tajikistan",
  "TH": "Thailand",
  "TW": "Taiwan",
  "TZ": "Tanzania",
  "TL": "East Timor",
  "TG": "Togo",
  "TK": "Tokelau",
  "TO": "Tonga",
  "TT": "Trinidad and Tobago",
  "TN": "Tunisia",
  "TR": "Turkey",
  "TM": "Turkmenistan",
  "TC": "Turks and Caicos Islands",
  "TV": "Tuvalu",
  "UG": "Uganda",
  "UA": "Ukraine",
  "UY": "Uruguay",
  "UZ": "Uzbekistan",
  "VU": "Vanuatu",
  "WF": "Wallis and Futuna",
  "VA": "Vatican",
  "VE": "Venezuela",
  "HU": "Hungary",
  "GB": "United Kingdom",
  "VN": "Vietnam",
  "IT": "Italy",
  "CI": "Ivory Coast",
  "BV": "Bouvet Island",
  "CX": "Christmas Island",
  "IM": "Isle of Man",
  "SH": "Saint Helena, Ascension and Tristan da Cunha",
  "AX": "Åland Islands",
  "CK": "Cook Islands",
  "VI": "US Virgin Islands",
  "HM": "Heard Island and McDonald Islands",
  "CC": "Cocos Islands",
  "MH": "Marshall Islands",
  "FO": "Faroe Islands",
  "SB": "Solomon Islands",
  "ST": "Sao Tome and Principe",
  "ZM": "Zambia",
  "ZW": "Zimbabwe",
  "AE": "United Arab Emirates"
}
